import { loadTemplate, templateStore } from '../template/index.js';
import { ambassadorStore } from './store.js';
import { sendInviteEmails } from './ajax.js';

export async function handleAddMailToInvite() {
	const container = document.getElementById('invite-via-email');
	if (!container) return;
	const input = container.querySelector('input[type="email"]');
	if (!input) return;
	const list = container.querySelector('#mail-list');
	if (!list) return;
	const addBtn = container.querySelector('button[data-action="add-email"]');
	if (!addBtn) return;
	await loadTemplate('ambassador/email-invite-item.ejs');

	const addEmail = () => {
		const email = input.value.trim();
		if (!email) return;

		const existsEmail = ambassadorStore.getEmails().find((e) => e === email);
		if (existsEmail) {
			wpcore.alert('error', wpcore.direct_t({ en: 'Email Already Exists', fr: 'L\'e-mail existe d\u00e9j\u00e0' }));
			input.value = '';
			return;
		}
		ambassadorStore.addEmail(email);
		// eslint-disable-next-line no-undef
		const emailItem = ejs.render(templateStore.get('ambassador/email-invite-item.ejs'), {
			email,
		});
		list.insertAdjacentHTML('afterbegin', emailItem);
		input.value = '';
	};

	addBtn.addEventListener('click', addEmail);

	input.addEventListener('keypress', (e) => {
		if (e.key === 'Enter') {
			e.preventDefault();
			addEmail();
		}
	});
}

export function handleRemoveEmailInvite() {
	const container = document.getElementById('invite-via-email');
	if (!container) return;
	const list = container.querySelector('#mail-list');
	if (!list) return;
	list.addEventListener('click', (e) => {
		const btn = e.target.closest('button[data-action="remove-email"]');
		if (!btn) return;

		e.preventDefault();
		e.stopPropagation();
		const email = btn.closest('[data-email]').dataset.email;
		btn.closest('[data-email]').remove();
		ambassadorStore.removeEmail(email);
	});
}

export function handleInviteViaEmail() {
	const container = document.getElementById('invite-via-email');
	if (!container) return;
	const btn = container.querySelector('button[data-action="invite-via-email"]');
	if (!btn) return;
	btn.addEventListener('click', async () => {
		btn.disabled = true;
		const emails = ambassadorStore.getEmails();
		if (emails.length === 0) {
			wpcore.alert('error', wpcore.direct_t({ en: 'Please add at least one email', fr: 'Veuillez ajouter au moins un e-mail' }));
			btn.disabled = false;
			return;
		}
		const response = await sendInviteEmails(emails);
		if (response.success) {
			wpcore.alert('success', response.message);
			wpcore.closePopup('invite-via-email');
			ambassadorStore.clearEmails();
			document.getElementById('mail-list').innerHTML = '';
		} else {
			wpcore.alert('error', response.message);
		}
		btn.disabled = false;
	});
}
